import { render, staticRenderFns } from "./SetDistributionDifference.vue?vue&type=template&id=1836ae32&scoped=true"
import script from "./SetDistributionDifference.vue?vue&type=script&lang=js"
export * from "./SetDistributionDifference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1836ae32",
  null
  
)

export default component.exports